// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#proof-share-recipient-keyword[data-v-15018f67]{display:none;width:auto;height:20px;border:none}#proof-share-recipient-keyword[data-v-15018f67]:focus{background-color:#f8f9fa}", ""]);
// Exports
module.exports = exports;
